import styled, { keyframes } from "styled-components";

const ease = "cubic-bezier(0.2, 0.7, 0.2, 1)";

// One forward nudge once the link has scrolled into view (Reveal adds
// .is-visible), then still; hover takes over from there.
const nudge = keyframes`
  0%, 100% { transform: translateX(0); }
  30% { transform: translateX(10px); }
  55% { transform: translateX(0); }
  75% { transform: translateX(5px); }
`;

export const LinkWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
`;

export const LinkContainer = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
`;

export const Label = styled.span`
  color: #0043ff;
  font-size: 1.34rem;
  font-weight: 500;
  padding-bottom: 2px;
  background: linear-gradient(currentColor, currentColor) no-repeat right bottom / 0 1px;
  transition: background-size 0.4s ${ease};
  ${LinkContainer}:hover & {
    background-position: left bottom;
    background-size: 100% 1px;
  }
  &.white {
    color: #fafbff;
  }
  @media (max-width: 768px) {
    font-size: 1.1rem
  }
`;

export const Arrow = styled.img`
  width: 30px;
  margin-left: 10px;
  transition: transform 0.35s ${ease};
  .is-visible & {
    animation: ${nudge} 1.1s ease-in-out 0.6s;
  }
  ${LinkContainer}:hover & {
    transform: translateX(8px);
  }
  @media (max-width: 768px) {
    width: 15px;
    margin-left: 6px;
  }
  @media (prefers-reduced-motion: reduce) {
    transition: none;
    .is-visible & {
      animation: none;
    }
  }
`;
